import { useCallback, useMemo, useState } from "react";

export interface Disclosure {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
}

export function useDisclosure(initial = false): Disclosure {
  const [open, setOpen] = useState(initial);

  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);
  const onToggle = useCallback(() => setOpen((value) => !value), []);

  return useMemo(
    () => ({ open, onOpen, onClose, onToggle }),
    [open, onOpen, onClose, onToggle],
  );
}
